import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { EmployeeReportPage } from '@/features/attendance/pages/EmployeeReportPage';
import { employeeReportQueryOptions } from '@/features/attendance/api/attendance.api';

const searchSchema = z.object({
  userId: z.number(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
});

export const Route = createFileRoute('/_auth/attendance/employee-report')({
  validateSearch: searchSchema,
  component: function EmployeeReportRoute() {
    const { userId, dateFrom, dateTo } = Route.useSearch();
    return (
      <ErrorBoundary moduleName="Employee Report">
        <Suspense fallback={<PageLoader />}>
          <EmployeeReportPage
            queryOptions={employeeReportQueryOptions}
            userId={userId}
            {...(dateFrom !== undefined && { dateFrom })}
            {...(dateTo !== undefined && { dateTo })}
            title="Employee Report"
          />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
